import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categoryAPI } from '../api/services';
import Loading from '../components/common/Loading';
import './Categories.css';

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    categoryAPI.getTree()
      .then(res => setCategories(res.data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <div className="categories-page">
      <div className="categories-header">
        <h1>Shop by Category</h1>
        <p>Browse our curated collections for your little ones</p>
      </div>

      {categories.length === 0 ? (
        <div className="empty-state">
          <h3>No categories available</h3>
          <p>Check back soon for new collections!</p>
        </div>
      ) : (
        <div className="categories-list">
          {categories.map(parent => (
            <div key={parent.id} className="cat-group">
              <Link to={`/shop?categoryId=${parent.id}`} className="cat-group-header">
                <div className="cat-group-icon">{parent.name.charAt(0)}</div>
                <div>
                  <h2>{parent.name}</h2>
                  {parent.description && <p>{parent.description}</p>}
                </div>
              </Link>
              {parent.children && parent.children.length > 0 && (
                <div className="cat-children-grid">
                  {parent.children.map(child => (
                    <Link key={child.id} to={`/shop?categoryId=${child.id}`} className="cat-child-card">
                      {child.imageUrl ? (
                        <img src={child.imageUrl} alt={child.name} />
                      ) : (
                        <div className="cat-child-placeholder">{child.name.charAt(0)}</div>
                      )}
                      <div className="cat-child-info">
                        <span className="cat-child-name">{child.name}</span>
                        {child.description && <span className="cat-child-desc">{child.description}</span>}
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
